<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <alert v-if="alert.copy" :type="alert.type" :title="alert.title" :copy="alert.copy"></alert>

                            <div class="article-wrapper">
                                <div class="panel">
                                    <header>
                                        <h1>Single Sign On</h1>
                                    </header>

                                    <div class="form">
                                        <div class="form__group">
                                            <label class="form__label" for="sso_enabled">Enable Single Sign On</label>

                                            <div class="select">
                                                <select id="sso_enabled" name="sso_enabled" class="form__control" v-model="account.sso_enabled">
                                                    <option value="0">Disabled</option>
                                                    <option value="1">Enabled - with link on login page</option>
                                                    <option value="2">Enabled - forced</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="sso_entity_id">Entity ID</label>
                                            <input type="text" id="sso_entity_id" name="sso_entity_id" class="form__control" v-model="account.sso_entity_id">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="sso_issuer_url">Issuer URL</label>
                                            <input type="text" id="sso_issuer_url" name="sso_issuer_url" class="form__control" v-model="account.sso_issuer_url" >
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="sso_x509_certificate">Certificate</label>
                                            <textarea id="sso_x509_certificate" name="sso_x509_certificate" class="form__control" rows="5" v-model="account.sso_x509_certificate"></textarea>
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="sso_enabled">Enable Single Sign On</label>

                                            <div>
                                                
                                            </div>
                                        </div>

                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Save Changes</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';

    // const Uppy = require('@uppy/core');
    // const XHRUpload = require('@uppy/xhr-upload');
    // const FileInput = require('@uppy/file-input');
    // const Url = require('@uppy/url');

    // require('@uppy/core/dist/style.css');
    // require('@uppy/url/dist/style.css');

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                alert: {
                    type: null,
                    title: null,
                    copy: null
                },
                account: {
                    sso_entity_id: null,
                    sso_issuer_url: null,
                    sso_x509_certificate: null,
                },
            }
        },
        mounted() {
            this.getAccount();
        },
        methods: {
            getAccount() {
                axios.get('/api/account/').then((response) => {
                    this.account = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            saveSettings(){
                axios.put('/api/account/sso', this.account).then((response) => {
                    this.account = response.data;
                    this.$store.commit('auth/setTeam', response.data);

                    window.scrollTo(0, 0);
                    this.alert.type = 'success';
                    this.alert.copy = [this.account.name + " settings have been updated"];
                }, (response) => {
                    this.error = response;
                });
            }
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>
